import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  homePageTitle: {
    description: 'title for the home page',
    defaultMessage: 'Welcome to ShipStation!',
    id: 'K6JAYm',
  },
  onboardTitle: {
    defaultMessage: 'Get ready to ship in three steps',
    description: 'title for the onboard steps',
    id: 'yuzT/i',
  },
  percentComplete: {
    defaultMessage: '{totalCompletedSteps}/{totalSteps} steps complete',
    description: 'percent complete for the onboard steps',
    id: 'xI5BMe',
  },
  saveSuccessMessage: {
    description: 'ship from save success growler message',
    defaultMessage: 'Ship From saved successfully',
    id: 'Ocvj/w',
  },
  shipFromCardTitleIncomplete: {
    defaultMessage: 'Set Ship From address',
    description: 'title for the ship from card when incomplete',
    id: 'QLIyM2',
  },
  shipFromCardTitleComplete: {
    defaultMessage: 'Ship From address set',
    description: 'title for the ship from card when complete',
    id: 'ztgDsI',
  },
  shipFromGuidingText: {
    defaultMessage: 'Add your Ship From address to view the most accurate shipping rates. Add more at any time.',
    description: 'guides user on how to set up ship from address',
    id: 'JPPMDr',
  },
  setShipFromButton: {
    defaultMessage: 'Set Ship From',
    description: 'button to set ship from address',
    id: 'sZ/lrg',
  },
  setShipFromButtonComplete: {
    defaultMessage: 'Add more Ship From locations',
    description: 'button to set another ship from address',
    id: '1C6qxH',
  },
  connectedAddress: {
    description: 'connected ship from address',
    defaultMessage: '{line1} {city} {state}, {postal}',
    id: 'ky1tKd',
  },
  shippingServicesWalletComplete: {
    defaultMessage: 'Shipping services added',
    description: 'title for the shipping services card when complete',
    id: 'fjRYhH',
  },
  shippingServicesBYOLComplete: {
    defaultMessage: 'Shipping services added',
    description: 'title for the shipping services card when complete by connecting a non-walleted label provider',
    id: 'oeJMoX',
  },
  shippingServicesCardTitleIncomplete: {
    defaultMessage: 'Add shipping services',
    description: 'title for the shipping services card when incomplete',
    id: 'BQ4uAe',
  },
  shippingServicesGuidingText: {
    defaultMessage: 'Save up to 89% off retail rates with ShipStation Carriers or connect your accounts from 100+ carriers, or both.',
    description: 'guides user on how to add shipping services',
    id: 'nmrkYP',
  },
  walletRegistrationButton: {
    defaultMessage: 'Add ShipStation Carriers',
    description: 'button to open the wallet registration modal',
    id: 'UwJ3dv',
  },
  shipStationCarriers: {
    defaultMessage: 'ShipStation Carriers',
    description: 'informs user that they can add walleted ShipStation carriers',
    id: 'dGHKP8',
  },
  connectCarrierButton: {
    defaultMessage: 'Connect Your Carriers',
    description: 'opens modal to select carriers',
    id: 'jeTnDo',
  },
  addAndManageCarrier: {
    defaultMessage: 'Add and manage carriers',
    description: 'button that links to where users add and manage carriers',
    id: 'uhbbKO',
  },
  connected: {
    defaultMessage: 'Connected',
    description: 'connected carrier',
    id: 't3BQFI',
  },
  manualOrder: {
    defaultMessage: 'Manual order',
    description: 'informs users new orders have been added',
    id: 'jqID6d',
  },
  created: {
    defaultMessage: 'Created',
    description: 'informs user that the orders have been created',
    id: 'tjrLvI',
  },
  labelProviderErrorTitle: {
    description: 'Title for error message when failure to connect to a provider on the home page',
    defaultMessage: 'ShipStation could not connect to the selected carrier.',
    id: 'lVLlXU',
  },
  labelProviderError: {
    description: 'Error message when failure to connect to a provider on the home page',
    defaultMessage: 'Confirm your account details and try connecting the carrier again.',
    id: '1WWHnN',
  },
  orderImportCardTitleIncomplete: {
    defaultMessage: 'Import your orders',
    description: 'title for the order import card when incomplete',
    id: 'nZ0HMW',
  },
  orderImportCardTitleCompleteOrders: {
    defaultMessage: 'Orders added',
    description: 'title for the order import card when complete by adding new orders',
    id: '2BmbVm',
  },
  orderImportCardGuidingText: {
    defaultMessage: 'ShipStation can import orders from multiple sources. Choose how you’d like to import the orders below.',
    description: 'guides user on how to import orders',
    id: 'Rz/7+C',
  },
  launchMarketplaceCUI: {
    defaultMessage: 'Connect Store',
    description: 'button to launch the marketplace CUI modal',
    id: 'tRtj/e',
  },
  importOrdersCSV: {
    defaultMessage: 'Upload',
    description: 'button to open import order CSV modal',
    id: 'V4TAOw',
  },
  create: {
    defaultMessage: 'Create',
    description: 'button to open the manual order creation modal',
    id: 'wzSCXy',
  },
  connectAndManageStores: {
    defaultMessage: 'Connect and manage stores',
    description: 'link to settings where user can connect and manage stores',
    id: 'aN/v27',
  },
  gotToOrders: {
    defaultMessage: 'Go to Orders',
    description: 'link to go to the orders page',
    id: 'SPAPfq',
  },
  fetchErrorNotificationTitle: {
    defaultMessage: 'Error fetching order count',
    description: 'title for the error notification when fetching order count',
    id: 'FdjNZM',
  },
  fetchErrorNotificationContent: {
    defaultMessage: 'There was an error fetching the order count. Please try again later.',
    description: 'content for the error notification when fetching order count',
    id: 'EyL+aZ',
  },
  gettingStarted: {
    description: 'Getting Started',
    defaultMessage: 'Getting Started',
    id: 'woPGUK',
  },
  gettingStartedButton: {
    defaultMessage: 'Getting Started <label>({totalCompletedSteps} of {totalSteps})</label>',
    description: 'Button to getting started popup',
    id: 'JEc/sp',
  },
  gettingStartedButtonComplete: {
    defaultMessage: 'Setup Complete <label>({totalCompletedSteps} of {totalSteps})</label>',
    description: 'Complete version of Button to getting started popup',
    id: 'Y9QCV/',
  },
  onboardingCompleteHeading: {
    defaultMessage: 'You did it!',
    description: 'Heading for the onboarding complete card',
    id: 'eyku7o',
  },
  onboardingCompleteTitleNoLabel: {
    defaultMessage: 'You’ve completed your essential steps!',
    description: 'title for the onboarding complete card when the basic steps are completed',
    id: 'VopRJc',
  },
  onboardingCompleteTitleLabel: {
    defaultMessage: 'You created your first label!',
    description: 'title for the onboarding complete card when a label was created',
    id: 'suDbm/',
  },
  onboardingCompleteBodyHomeNoLabel: {
    defaultMessage:
      'If you are ready to ship, go to the Orders page. Come back to the Home page any time to learn about all the powerful features ShipStation has to offer.',
    description: 'body for the onboarding complete card when the basic steps are completed on the home page',
    id: 'z3ocfd',
  },
  onboardingCompleteBodyHomeLabel: {
    defaultMessage:
      'Find your labels in the Shipments tab. Ship more or come back to the Home page any time to learn about all the powerful features ShipStation has to offer.',
    description: 'body for the onboarding complete card when printing a label from the home page',
    id: 've9qMg',
  },
  onboardingCompleteBodyOnboardNoLabel: {
    defaultMessage:
      'If you are ready to ship, go to the Orders page. Come back to the Onboarding page any time to learn about all the powerful features ShipStation has to offer.',
    description: 'body for the onboarding complete card when the basic steps are completed on the home page',
    id: 'J+vFme',
  },
  onboardingCompleteBodyOnboardLabel: {
    defaultMessage:
      'Find your labels in the Shipments tab. Ship more or come back to the Onboarding page any time to learn about all the powerful features ShipStation has to offer.',
    description: 'body for the onboarding complete card when printing a label from the home page',
    id: '6ROogV',
  },
  onboardingCompleteGoToOrders: {
    defaultMessage: 'Go to orders',
    description: 'Primary action button onboarding complete card, navigates to orders page',
    id: 'nqcZAR',
  },
  onboardingCompleteStayOnOrders: {
    defaultMessage: 'Configure more orders',
    description: 'Primary action button onboarding complete card, remains on orders page',
    id: '+vXRHc',
  },
  onboardingCompleteGoToHome: {
    defaultMessage: 'Explore Home Page',
    description: 'Primary action button onboarding complete card, navigates to home page',
    id: 'cwai89',
  },
  onboardingCompleteStayOnHome: {
    defaultMessage: 'Stay on Home Page',
    description: 'Primary action button onboarding complete card, remains on home page',
    id: 'qI/i48',
  },
  checkoutRatesTitleIncomplete: {
    defaultMessage: 'Configure Checkout Rates',
    description: 'title for the Checkout Rates card',
    id: 'MFtkrc',
  },
  checkoutRatesTitleComplete: {
    defaultMessage: 'Checkout Rates Configured',
    description: 'title for the Checkout Rates card',
    id: 'KJ9+eF',
  },
  checkoutRatesBodyIncomplete: {
    defaultMessage: 'Set up live rates to offer your customers more shipping options at checkout.',
    description: 'body for the Checkout Rates card',
    id: 'MvKZGT',
  },
  checkoutRatesBodyComplete: {
    defaultMessage: 'Offer your customers live rates and more shipping options at checkout.',
    description: 'body for the Checkout Rates card',
    id: 'MXK+Ra',
  },
  checkoutRatesButton: {
    defaultMessage: 'Configure Rates',
    description: 'Primary button for the Checkout Rates card',
    id: 'y72DaE',
  },
  checkoutRatesDismissButton: {
    defaultMessage: 'Setup later',
    description: 'Secondary button for the Checkout Rates card',
    id: 'N9hvl/',
  },
  dismissGuideButton: {
    defaultMessage: 'Dismiss Guide',
    description: 'Button to close and remove the onboarding guide from the home page',
    id: 'bUdVwL',
  },
  providersAltText: {
    defaultMessage: 'service providers from ShipStation wallet',
    description: 'Alt text for the providers icon',
    id: 'kCeNkX',
  },
  shipFromAltText: {
    defaultMessage: 'dot in a teardrop shape connoting a location',
    description: 'Alt text for the ship from icon',
    id: 'c3GNta',
  },
  orderImportAltText: {
    defaultMessage: 'logos from popular store integrations',
    description: 'Alt text for the order import icon',
    id: 'WDyBUj',
  },
  walletConnected: {
    defaultMessage: 'Savings enabled!',
    description: 'message when the wallet is connected',
    id: 'nSEBaU',
  },
  BYOLConnected: {
    defaultMessage: '{carrier} enabled!',
    description: 'message when a non-walleted carrier is connected',
    id: 'NxNQwe',
  },
  connectedStoreTitle: {
    defaultMessage: '{store} connected!',
    description: 'title for the connected store',
    id: 'ImNesF',
  },
  orderImportCardCompleteOrders: {
    defaultMessage: 'Manual Order(s) created',
    description: 'title for the order import card when complete by adding new orders',
    id: 'tjWM8t',
  },
});
